// components/AuthCheck.js
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setUser } from '../features/userSlice';
import axios from 'axios';

const AuthCheck = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (!token) return;

    const fetchUser = async () => {
      try {
        const response = await axios.get(
            'http://localhost:8000/api/user/',
            {headers: {Authorization: `Bearer ${token}`}}
        );
        dispatch(setUser({user: response.data, token}));
      } catch (err) {
        console.error('Ошибка авторизации:', err);
        localStorage.removeItem('authToken'); // Удаляем невалидный токен
      }
    };

    fetchUser();
  }, [dispatch]);

  return null;
};

export default AuthCheck;